var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row sessies-page" }, [
    _c("div", { staticClass: "col-12 col-md-6 sessies" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _vm._m(1),
          _vm._v(" "),
          _vm._l(_vm.boekingen, function(boeking) {
            return _c("div", { key: boeking.id, staticClass: "col-12 mb-2" }, [
              _c(
                "div",
                {
                  staticClass: "card",
                  class: { active: _vm.selected_id == boeking.id },
                  on: {
                    click: function($event) {
                      return _vm.handleSelect(boeking.id)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-5" }, [
                        _c("h4", { staticClass: "mb-0" }, [
                          _vm._v(_vm._s(boeking.title))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-3" }, [
                        _vm._v(_vm._s(boeking.date))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-3 boeking-badge",
                          class: {
                            cancelled: boeking.cancelled,
                            accepted: boeking.is_definitive
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              boeking.cancelled
                                ? "Geannuleerd"
                                : boeking.is_definitive
                                ? "Goedgekeurd"
                                : "Voorlopig"
                            )
                          )
                        ]
                      )
                    ])
                  ])
                ]
              )
            ])
          }),
          _vm._v(" "),
          _vm.max_num_pages > 1
            ? _c("div", { staticClass: "col-12 mb-3" }, [
                _c(
                  "nav",
                  { attrs: { "aria-label": "Page navigation example" } },
                  [
                    _c(
                      "ul",
                      { staticClass: "pagination" },
                      [
                        _vm.page > 1
                          ? _c("li", { staticClass: "page-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "page-link",
                                  attrs: { "aria-label": "Vorige" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handlePagination("prev")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { "aria-hidden": "true" } },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "7",
                                            height: "10",
                                            viewBox: "0 0 7 10",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg"
                                          }
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M4.96976 9.2793L6.03026 8.2188L2.81051 4.99905L6.03026 1.7793L4.96976 0.718797L0.689514 4.99905L4.96976 9.2793Z",
                                              fill: "#21386E"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Vorige")
                                  ])
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.max_num_pages, function(n) {
                          return _c(
                            "li",
                            {
                              key: n,
                              staticClass: "page-item",
                              class: { active: n == _vm.page }
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "page-link",
                                  on: {
                                    click: function($event) {
                                      return _vm.handlePagination(n)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(n))]
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.page < _vm.max_num_pages
                          ? _c("li", { staticClass: "page-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "page-link",
                                  attrs: { "aria-label": "Volgende" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handlePagination("next")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { "aria-hidden": "true" } },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "7",
                                            height: "10",
                                            viewBox: "0 0 7 10",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg"
                                          }
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M2.03024 0.720703L0.969736 1.7812L4.18949 5.00095L0.969735 8.2207L2.03023 9.2812L6.31049 5.00095L2.03024 0.720703Z",
                                              fill: "#21386E"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Volgende")
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                )
              ])
            : _vm._e()
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12 col-md-6" },
      [
        _vm.selected_id
          ? _c("boeking", {
              attrs: {
                expert: _vm.expert,
                ajax: _vm.ajax,
                id: _vm.selected_id
              },
              on: { accepted: _vm.setAccepted }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-2" }, [
      _c("div", { staticClass: "col" }, [_c("h2", [_vm._v("Boekingen")])]),
      _vm._v(" "),
      _c("div", { staticClass: "col-auto" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 mb-2" }, [
      _c("div", { staticClass: "card top" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-5" }, [
              _c("h3", { staticClass: "mb-0" }, [_vm._v("Titel")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-3" }, [
              _c("h3", { staticClass: "mb-0" }, [_vm._v("Datum")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-3" }, [
              _c("h3", { staticClass: "mb-0" }, [_vm._v("Status")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-1" })
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib?{}!./scripts/vue/Boekingen.vue?vue&type=template&id=1d54fe34&scoped=true&
// module id = 438
// module chunks = 0